import gql from 'graphql-tag';

export const USER_LIST = gql`
query{ 
    users {
        id
        name
        username
        isAdmin
        accessAuthorizations{
            id 
            canPerformActions
        }
    }
}`;

export const PROJECT_LIST = gql`
query{
    projects{
        id
        name
    }
}`;

export const CREATE_USER = gql`
mutation CreateUser(
    $username: String!, 
    $name: String!,
    $password: String!,
    $isAdmin: Boolean!,
    $projects: [ProjectInput]
    ){
        createUser(
            username: $username,
            name: $name,
            password: $password,
            isAdmin: $isAdmin, 
            projects: $projects
        ){
            username
        }
    }
`;

export const REMOVE_USER = gql`
mutation RemoveUser($id: String!){
    removeUser(id:$id)
}
`;

export const RESET_PASSWORD = gql`
mutation ResetPassword($id: String!){
    resetPassword(id:$id)
}
`;

export const EDIT_USER = gql`
mutation EditUser(
    $id: String!
    $name: String
    $username: String
    $isAdmin: Boolean!
    $projects: [ProjectInput]
    ){
        editUser(
            id: $id,
            username: $username,
            name: $name,
            isAdmin: $isAdmin, 
            projects: $projects 
        )
    }
`